export default __webpack_public_path__ + "static/media/00_video_postcard.85f3a786.png";